import React from 'react';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin,
  Send
} from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-blue-950 to-slate-950 text-white font-sans">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <div className="bg-gradient-to-br from-blue-600 to-teal-500 text-white p-2 rounded-xl ml-3 shadow-lg">
                <div className="w-8 h-8 flex items-center justify-center font-bold text-lg">
                  النخبه
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold">معمل النخبه</h3>
                <p className="text-blue-200/70 text-sm">تحاليل طبية دقيقة وموثوقة</p>
              </div>
            </div>
            <p className="text-blue-100/60 leading-relaxed">
              نقدم أحدث التقنيات في التحاليل الطبية مع فريق من الخبراء المتخصصين 
              لضمان الحصول على نتائج دقيقة وسريعة.
            </p>

            {/* Newsletter */}
            <div>
              <h5 className="font-semibold mb-3">اشترك في نشرتنا الإخبارية</h5>
              <div className="flex space-x-2 rtl:space-x-reverse">
                <input 
                  type="email"
                  placeholder="بريدك الإلكتروني" 
                  className="w-full p-2 rounded-lg bg-white/5 border border-white/10 text-white placeholder-blue-200/40 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                />
                <button 
                  type="button" 
                  className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-teal-500 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
                >
                  <Send className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative inline-block">
              روابط سريعة
              <span className="absolute -bottom-2 right-0 w-8 h-0.5 rounded-full bg-teal-500"></span>
            </h4>
            <ul className="space-y-3 mt-5">
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">الرئيسية</a></li>
              <li><a href="#services" className="text-blue-100/60 hover:text-teal-400 transition-colors">خدماتنا</a></li>
              <li><a href="#packages" className="text-blue-100/60 hover:text-teal-400 transition-colors">الباقات المتخصصة</a></li>
              <li><a href="#tests" className="text-blue-100/60 hover:text-teal-400 transition-colors">التحاليل الفردية</a></li>
              <li><a href="#about" className="text-blue-100/60 hover:text-teal-400 transition-colors">من نحن</a></li>
              <li><a href="#contact" className="text-blue-100/60 hover:text-teal-400 transition-colors">تواصل معنا</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative inline-block">
              خدماتنا
              <span className="absolute -bottom-2 right-0 w-8 h-0.5 rounded-full bg-teal-500"></span>
            </h4>
            <ul className="space-y-3 mt-5">
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">تحليل Inbody</a></li>
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">الزيارة المنزلية</a></li>
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">خدمة عملاء 24/7</a></li>
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">استشارة طبية</a></li>
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">قياس الضغط مجاناً</a></li>
              <li><a href="#home" className="text-blue-100/60 hover:text-teal-400 transition-colors">خدمة لغة الإشارة</a></li>
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h4 className="text-lg font-semibold mb-4 relative inline-block">
              تواصل معنا
              <span className="absolute -bottom-2 right-0 w-8 h-0.5 rounded-full bg-teal-500"></span>
            </h4>
            <div className="space-y-3 mb-6 mt-5">
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-teal-400 shrink-0" />
                <span className="text-blue-100/60 hover:text-white transition-colors">012-3456-7890</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-teal-400 shrink-0" />
                <span className="text-blue-100/60 hover:text-white transition-colors">011-2348-5678</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-teal-400 shrink-0" />
                <span className="text-blue-100/60 hover:text-white transition-colors">Elite@medicallab.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-teal-400 shrink-0" />
                <span className="text-blue-100/60 hover:text-white transition-colors">support@medicallab.com</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-teal-400 shrink-0" />
                <span className="text-blue-100/60 hover:text-white transition-colors">القاهرة - حي النزهة</span>
              </div>
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-teal-400 shrink-0" />
                <span className="text-blue-100/60 hover:text-white transition-colors">الزقازيق - القومية </span>
              </div>
            </div>
            {/* Social Media Links */}
            <div className="flex space-x-3 rtl:space-x-reverse">
              <button 
                type="button"
                className="w-9 h-9 flex items-center justify-center text-blue-100/60 hover:text-white bg-white/5 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-500 transition-all duration-300 rounded-full"
              >
                <Facebook className="w-4 h-4" />
              </button>
              <button 
                type="button"
                className="w-9 h-9 flex items-center justify-center text-blue-100/60 hover:text-white bg-white/5 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-500 transition-all duration-300 rounded-full"
              >
                <Twitter className="w-4 h-4" />
              </button>
              <button 
                type="button"
                className="w-9 h-9 flex items-center justify-center text-blue-100/60 hover:text-white bg-white/5 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-500 transition-all duration-300 rounded-full"
              >
                <Instagram className="w-4 h-4" />
              </button>
              <button 
                type="button"
                className="w-9 h-9 flex items-center justify-center text-blue-100/60 hover:text-white bg-white/5 hover:bg-gradient-to-br hover:from-blue-600 hover:to-teal-500 transition-all duration-300 rounded-full"
              >
                <Linkedin className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-blue-100/60 text-sm">
              © 2025 معمل النخبه جميع الحقوق محفوظة
            </p>
            <div className="flex flex-wrap justify-center gap-8">
              <Link 
                to="/privacy-policy"
                className="text-blue-100/60 hover:text-teal-400 text-sm transition-colors"
              >
                سياسة الخصوصية
              </Link>
              <Link 
                to="/terms-of-use"
                className="text-blue-100/60 hover:text-teal-400 text-sm transition-colors"
              >
                شروط الاستخدام
              </Link>
              <Link 
                to="/cookie-policy"
                className="text-blue-100/60 hover:text-teal-400 text-sm transition-colors"
              >
                سياسة الكوكيز
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
